import { useNavigate } from "react-router-dom";
import moment from "jalali-moment";
import { Button } from "antd";
import { hejriDate } from "@helpers/financial_helper";
import { FieldMarkerIcon } from "@/components/map/utils/customs";
import { toolbarBaseControls } from "@/features/map/utils/configs";
import AgroMapFarm from "@/features/map/presentation/components/AgroMapFarm";
import Chart from "@/components/reports/cultivar-recommendation/components/GddBase/Chart";
import TableGdd from "@/components/reports/cultivar-recommendation/components/GddBase/TableGdd";
import line from "@assets/images/cultivar_recommendation_report_images/Line185.png";
import frame2182 from "@assets/images/cultivar_recommendation_report_images/Frame2182.png";
import headerImage from "@assets/images/cultivar_recommendation_report_images/headerImage.png";
import footerImage from "@assets/images/cultivar_recommendation_report_images/footerImage.png";
import footerTitle from "@assets/images/cultivar_recommendation_report_images/footerTitle.png";
import agroyaarPlatform from "@assets/images/cultivar_recommendation_report_images/agroyaarPlatform.png";
import cultivarRecommendationIcon from "@assets/images/cultivar_recommendation_report_images/cultivarRecommendationIcon.png";

function GddBase({ cultivarReport, cultivarRecommendationsAnalysisResult }) {
  const navigate = useNavigate();

  let pageNumber = 0;

  return (
    <div className="section-container flex flex-col items-center justify-center w-[720px] mx-auto !bg-white">
      {/* Page1 (Introduction) */}
      <div className="page1">
        <div className="flex flex-col justify-between items-center w-full h-[1048px]">
          <img
            className="header"
            src={headerImage}
            alt="header"
            width="750px"
          />

          <div className="flex flex-col justify-between items-center w-full gap-14 mt-[-30px]">
            <p
              className="text-[#222] text-[29px] font-bold text-center !font-[B-Nazanin]"
              style={{ textShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)" }}
            >
              کشاورزی{" "}
              <span className="text-president !font-[B-Nazanin]">
                مطمئن‌
                <span className="text-[#222] !font-[B-Nazanin]">تر، </span>
              </span>
              <span className="text-president !font-[B-Nazanin]">
                دقیق‌
                <span className="text-[#222] !font-[B-Nazanin]">تر و </span>
              </span>
              <span className="text-president !font-[B-Nazanin]">
                اقتصادی‌
                <span className="text-[#222] !font-[B-Nazanin]">تر</span>
              </span>
              <p className="text-[#000] font-semibold text-[20px] whitespace-nowrap !font-[B-Nazanin]">
                هدف ما تصمیم‌گیری برای کشاورز نیست، کمک به تصمیم‌گیری بهتر
                کشاورز است
              </p>
            </p>

            <div className="flex flex-col items-center">
              <img
                src={cultivarRecommendationIcon}
                className="w-[240px] h-[224px] !font-[B-Nazanin]"
                alt="cultivar-icon"
              />
              <div className="flex flex-col items-center">
                <span
                  className="text-[#5700B4] font-bold text-[36px] !font-[B-Nazanin]"
                  style={{
                    textShadow: "1px 0px 3px rgba(118, 118, 118, 0.61)",
                  }}
                >
                  گزارش انتخاب رقم مناسب
                </span>
                <span className="text-[#5700B4] font-bold text-[26px] !font-[B-Nazanin]">
                  {" "}
                  بر اساس درجه روز رشد (GDD)
                </span>
              </div>
            </div>
            <img
              src={line}
              alt="line"
              width="750px"
              className="mt-[-90px] mr-0 mb-[-45px] ml-0"
            />
            <div className="flex flex-row justify-start items-center w-full gap-5 mt-[-30px] px-4">
              <div className="flex flex-col justify-between items-start w-[50%] gap-2">
                <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
                  اطلاعات کشاورز
                </span>

                <div className="flex flex-row-reverse justify-end items-center gap-[19px] w-full">
                  <div className="text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                    <span className="!font-[B-Nazanin]">
                      {cultivarReport?.farmer?.firstName}{" "}
                      {cultivarReport?.farmer?.lastName}
                    </span>

                    <div className="flex flex-row items-start gap-2">
                      <span className="!font-[B-Nazanin]">کد کشاورزی:</span>
                      <span className="!font-sans text-[16px]">
                        {cultivarReport?.farmer?.farmerCode}
                      </span>
                    </div>

                    <div className="flex flex-row items-start gap-2">
                      <span className="!font-[B-Nazanin]">استان و شهر:</span>
                      <span className="!font-[B-Nazanin]">
                        {cultivarReport?.farmer?.province?.name}،{" "}
                        {cultivarReport?.farmer?.city?.name}
                      </span>
                    </div>
                  </div>

                  <img
                    src={
                      process.env.REACT_APP_ARVAN_S3_BASE_URL +
                      cultivarReport?.farmer?.avatar
                    }
                    alt="profile"
                    width="70px"
                    height="70px"
                    className="rounded-full border-[2px] border-solid border-president"
                  />
                </div>
              </div>
              {cultivarReport?.expert && (
                <div className="flex flex-col justify-center items-start w-[50%] gap-2">
                  <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
                    اطلاعات کارشناس
                  </span>

                  <div className="flex flex-row-reverse justify-end items-center gap-[19px] w-full">
                    <div className="text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                      <span className="!font-[B-Nazanin]">
                        {cultivarReport?.farmer?.firstName}{" "}
                        {cultivarReport?.farmer?.lastName}
                      </span>

                      <div className="flex flex-row items-start gap-2">
                        <span className="!font-[B-Nazanin]">کد کارشناس:</span>
                        <span className="!font-sans text-[16px]">
                          {cultivarReport?.farmer?.farmerCode}
                        </span>
                      </div>

                      <div className="flex flex-row items-start gap-2">
                        <span className="!font-[B-Nazanin]">استان و شهر:</span>
                        <span className="!font-[B-Nazanin]">
                          {cultivarReport?.farmer?.province?.name}،{" "}
                          {cultivarReport?.farmer?.city?.name}
                        </span>
                      </div>
                    </div>

                    <img
                      src={
                        process.env.REACT_APP_ARVAN_S3_BASE_URL +
                        cultivarReport?.farmer?.avatar
                      }
                      alt="profile"
                      width="70px"
                      height="70px"
                      className="rounded-full border-[2px] border-solid border-president"
                    />
                  </div>
                </div>
              )}
            </div>

            <img
              src={line}
              alt="line"
              width="750px"
              className="mt-[-90px] mr-0 mb-[-45px] ml-0"
            />

            <div className="flex flex-row justify-center items-end w-full gap-7 px-4">
              <div className="flex flex-col justify-center items-start w-[50%] gap-2">
                <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin]">
                  اطلاعات زمین
                </span>

                <div className="flex flex-row-reverse justify-end items-center gap-[19px] w-full">
                  <div className="text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                    <div className="flex flex-row items-start w-full justify-between gap-2">
                      <span className="!font-[B-Nazanin]">نام قطعه:</span>
                      <span className="!font-[B-Nazanin]">
                        {cultivarReport?.season?.farm?.name}
                      </span>
                    </div>

                    <div className="flex flex-row items-start w-full justify-between gap-2">
                      <span className="!font-[B-Nazanin]"> استان:</span>
                      <span className="!font-[B-Nazanin]">
                        {cultivarReport?.season?.farm?.province?.name}
                      </span>
                    </div>

                    <div className="flex flex-row items-start w-full justify-between gap-2">
                      <span className="!font-[B-Nazanin]">شهر:</span>
                      <span className="!font-[B-Nazanin]">
                        {cultivarReport?.season?.farm?.city?.name}
                      </span>
                    </div>
                  </div>

                  <div className="relative w-[80px] h-[80px] overflow-clip rounded-[999px]">
                    <div className="THISISFORMAPLOCK! bg-transparent z-[99999999] w-full h-full absolute"></div>
                    <AgroMapFarm
                      mapId={cultivarReport?.season?.farm?.id}
                      type="onlyShow"
                      toolbarOptions={toolbarBaseControls}
                      markerIcon={FieldMarkerIcon}
                      currentFarmPolygon={cultivarReport?.season?.farm?.polygon}
                    />
                  </div>
                </div>
              </div>

              <div className="flex flex-col justify-center items-start w-[50%] gap-2">
                <span className="font-bold text-[20px] text-[#222] !font-[B-Nazanin] items-start">
                  اطلاعات فصل رشد
                </span>
                <div className="flex flex-row-reverse justify-end items-center gap-[19px] w-full">
                  <div className="text-agrotext font-bold text-[18px] flex flex-col justify-center items-start gap-[6px]">
                    <div className="flex flex-row items-start w-full justify-between gap-2">
                      <span className="!font-[B-Nazanin]">نام محصول:</span>
                      <span className="!font-[B-Nazanin]">
                        {cultivarReport?.season?.product?.persianName}
                      </span>
                    </div>

                    <div className="flex flex-row items-start w-full justify-between gap-2 ">
                      <span className="!font-[B-Nazanin]">مساحت زمین</span>
                      <span className="!font-[B-Nazanin]">
                        {cultivarReport?.season?.area} هکتار
                      </span>
                    </div>

                    <div className="flex flex-row items-start w-full justify-between gap-2">
                      <span className="!font-[B-Nazanin]">فصل رشد:</span>
                      <span className="!font-[B-Nazanin]">
                        {moment(
                          `${cultivarReport?.season?.growingSeason}-04-01`,
                          "YYYY-MM-DD"
                        )
                          .locale("fa")
                          .format("YYYY")}{" "}
                        {cultivarReport?.season?.persianName
                          ? ` - ${cultivarReport?.season?.persianName}`
                          : ""}
                      </span>
                    </div>
                  </div>

                  <img
                    src={cultivarReport?.season?.product?.imageUrl}
                    alt="product-name"
                    width="80px"
                    height="80px"
                    className="rounded-full"
                  />
                </div>
              </div>
            </div>

            <img
              src={line}
              alt="line"
              width="750px"
              className="mt-[-90px] mr-0 mb-[-30px] ml-0"
            />
          </div>

          <div className="footer w-full flex flex-col mt-[90px] justify-start items-center relative">
            <img
              className="absolute bottom-0 z-[2]"
              src={footerImage}
              width="750px"
              alt="footer"
            />
            <img
              className="absolute bottom-2 left-[30px] z-[3]"
              src={footerTitle}
              alt="footer-title"
            />
            <span className="absolute bottom-1 left-[60px] z-[3] text-[12px] font-bold text-[#fff] tracking-[9px] text-center">
              WWW.AGROYAAR.COM
            </span>
            <span className="absolute bottom-[5px] right-[15px] z-[3] text-[18px] font-semibold text-[#fff]">
              {++pageNumber}
            </span>
          </div>
        </div>
      </div>

      {/* <!-- Page2 --> */}
      <div className="page2">
        <div className="flex flex-col justify-between items-center w-full h-[1048px]">
          <img className="header" src={frame2182} alt="header" width="720px" />

          <div className="flex flex-col justify-between items-center w-full gap-4 px-8 mt-[-90px]">
            <div className="flex flex-col px-8 gap-2">
              <h2 className=" text-lg font-bold !font-[B-Nazanin]">
                درجه روز رشد یا GDD چیست؟
              </h2>
              <p className=" text-sm leading-5 font-medium !font-[B-Nazanin]">
                گیاهان برای رشد نیاز به دماهای مشخصی دارند. گیاه یک ظرف تجمع
                دمایی به نام GDD دارد که با تجربه دماهای مشخصی در روز، رشد اتفاق
                میافتد. به طوری که روزی که گیاه دمای بیشتری تجربه کند سرعت رشد
                بیشتری داشته و در روزهای سرد سرعت رشد کمتری دارد.
              </p>
            </div>
            <div className="flex flex-col px-8 gap-2">
              <h2 className=" text-lg font-bold !font-[B-Nazanin]">
                ارقام مناسب بر اساس درجه روز رشد (GDD)
              </h2>
              <p className=" text-sm font-medium leading-5 !font-[B-Nazanin]">
                دراین گزارش ارقامی پیشنهاد شده است که در بازه فصل رشد انتخابی
                توسط شما، میتوانند مراحل سبز شدن تا برداشت را در زمان مناسبی طی
                کنند. این ارقام در بازه تاریخ کاشت تا برداشتی که ذکر کرده اید
                قابلیت کاشت دارند.
              </p>
            </div>
            <div className="flex flex-col w-full px-8 items-start gap-2">
              <h2 className="text-agrotext text-lg max-lg:text-sm font-medium !font-[B-Nazanin]">
                نمودار زیر، روند تجمیع واحد گرمایی را بر اساس اطلاعات ایستگاه
                هواشناسی{" "}
                <span className="text-[#460f81e7] !font-[B-Nazanin]">
                  ({cultivarReport?.weatherStation?.name})
                </span>{" "}
                نشان می‌دهد
              </h2>
              <div className="flex flex-row gap-2 text-[#333] font-semibold text-lg">
                <h3 className="!font-[B-Nazanin]">بازه فصل رشد:</h3>
                <p className="font-semibold !font-[B-Nazanin]">
                  {hejriDate(cultivarReport?.plantingDate)} -{" "}
                  {hejriDate(cultivarReport?.harvestDate)}
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center w-full mt-[-10px]">
              <Chart chartCultivarData={cultivarReport} />

              <div className="flex flex-col items-start mt-[-10px] gap-2">
                <div className="NiazSarmaii flex flex-row justify-center items-center gap-3 rounded-2xl ">
                  <span className="text-right text-[#333333] text-lg max-lg:text-xs font-semibold !font-[B-Nazanin]">
                    مقدار انباشت گرمایی
                  </span>
                  <div className="inner-circle-neo px-4 max-lg:px-4 !rounded-2xl justify-center items-center flex">
                    <span
                      className="text-center text-purple-900 text-lg max-lg:text-sm font-semibold !font-[B-Nazanin]"
                      dir="ltr"
                    >
                      {cultivarReport?.totalGrowingDegreeDays}
                    </span>
                  </div>
                  <span className="text-right text-[#333333] text-lg max-lg:text-xs font-semibold !font-[B-Nazanin]">
                    واحد گرمایی بوده است
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-center justify-start w-full h-full px-4">
              <span className="w-full text-right text-[#404848] !font-[B-Nazanin] text-lg font-bold mb-[-10px]">
                ارقام مناسب بازه فصل رشد انتخابی شما :
              </span>

              <TableGdd
                tableAnalysis={cultivarRecommendationsAnalysisResult}
                plantingDate={hejriDate(cultivarReport?.plantingDate)}
                harvestDate={hejriDate(cultivarReport?.harvestDate)}
                totalGrowingDegreeDays={cultivarReport?.totalGrowingDegreeDays}
              />
            </div>
          </div>

          <div className="footer w-full flex flex-col justify-start items-center relative bottom-0">
            <img
              className="absolute bottom-0 z-[2]"
              src={footerImage}
              width="720px"
              alt="footer"
            />
            <img
              className="absolute bottom-2 left-[30px] z-[3]"
              src={agroyaarPlatform}
              alt="footer"
            />
            <span className="absolute bottom-[5px] left-[60px] z-[3] text-[12px] font-bold text-[#fff] !font-sans">
              کد گزارش: {cultivarReport?.cultivarRecommendationCode}
            </span>
            <span className="absolute bottom-[5px] right-[40px] z-[3] text-[18px] font-semibold text-[#fff]">
              {++pageNumber}
            </span>
          </div>
        </div>
      </div>

      <div className="flex flex-col">
        <Button
          className="button-neo h-fit !text-[#333] hover:brightness-105 fixed top-[20px] right-[100px] max-lg:right-[32px] px-8 text-[18px]  w-[150px]"
          id="download-button"
          onClick={() => window.print()}
        >
          <p>پرینت گزارش</p>
        </Button>
        <Button
          className="button-neo h-fit !text-[#333] hover:brightness-105 fixed top-[65px] right-[100px] max-lg:right-[32px] px-8 text-[18px] w-[150px]"
          id="download-button"
          onClick={() => window.close()}
        >
          <p> بازگشت</p>
        </Button>
      </div>
    </div>
  );
}

export default GddBase;
